class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
        this.closeTimer = null;
        this.wrappers = this.querySelectorAll('.header-menu.mega');

        this.wrappers.forEach((wrapper) => {
            const trigger = wrapper.querySelector(':scope > a');
            const content = wrapper.querySelector(':scope > .header-menu-content');
            if (content) content.inert = true;

            wrapper.addEventListener('mouseenter', () => this.menuOpen(wrapper, trigger, content));
            wrapper.addEventListener('mouseleave', () => this.menuClose(wrapper, trigger, content));

            if (trigger) {
                trigger.addEventListener('keydown', (event) => this.handleTriggerKeydown(event, wrapper, trigger, content));
            }

            if (content) {
                content.addEventListener('mouseenter', () => this.menuEnter());
                content.addEventListener('mouseleave', () => this.menuClose(wrapper, trigger, content));
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.wrappers.forEach((wrapper) => {
                    const trigger = wrapper.querySelector(':scope > a');
                    const content = wrapper.querySelector(':scope > .header-menu-content');
                    if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
                        this.forceClose(wrapper, trigger, content);
                        trigger.focus();
                    }
                });
            }
        });
    }

    handleTriggerKeydown(event, wrapper, trigger, content) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.menuOpen(wrapper, trigger, content);
        }
    }

    forceClose(wrapper, trigger, content) {
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
        document.querySelector('body').classList.remove('desktop-menu-open');
        document.querySelector('body').classList.remove('desktop-menu-closing');
        wrapper.classList.remove('active');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (content) content.inert = true;
    }

    menuClose(wrapper, trigger, content) {
        let $self = this;
        this.timer = setTimeout(function () {
            document.querySelector('body').classList.remove('desktop-menu-open');
            document.querySelector('body').classList.add('desktop-menu-closing');
            wrapper.classList.remove('active');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (content) content.inert = true;
            $self.closeTimer = setTimeout(function () {
                document.querySelector('body').classList.remove('desktop-menu-closing');
            }, 400);
        }, 200);
    }

    menuEnter() {
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
        document.querySelector('body').classList.remove('desktop-menu-closing');
    }

    menuOpen(wrapper, trigger, content) {
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
        wrapper.classList.add('active');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (content) content.inert = false;
        document.querySelector('body').classList.add('desktop-menu-open');
        document.querySelector('body').classList.remove('desktop-menu-closing');
        this.wrappers.forEach((otherWrapper) => {
            if (otherWrapper !== wrapper) {
                otherWrapper.classList.remove('active');
                const otherTrigger = otherWrapper.querySelector(':scope > a');
                if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            }
        });
    }
}

customElements.define('mega-menu', MegaMenu);